import { ENV } from '@sitegen/common/constants/environments';

export const ANALYTICS_SCRIPT_URL = {
    [ENV.DEV]: 'https://ubistatic-a.ubisoft.com/0106/uat/global/tracking/analyticssdk.js',
    [ENV.PROD]: 'https://ubistatic-a.ubisoft.com/0106/prod/global/tracking/analyticssdk.js'
};

export const ANALYTICS_GLOBAL_NS = 'wa_data';
export const ANALYTICS_SDK = 'adobeAnalytics';
export const ANALYTICS_READY_EVENT = 'S_CODE_READY';

export enum ANALYTICS_EVENTS {
    FLOW_EVENT = 'flowevent',
    PAGE_EVENT = 'pageevent',
    CLICK_EVENT = 'clickevent',
    ERROR_EVENT = 'clickevent',
    ACCOUNT_EVENT = 'accountevent',
}

export const ANALYTICS_ATTRIBUTES = {
    category: 'login',
    action: {
        // when user lands on a page
        signedIn: 'signed in',
        signedOut: 'signed out',

        // when login/log out calls
        signingIn: 'signing in',
        signingOut: 'signing out'
    }
};

export const DEFAULT_LOCATION = 'page' as const;

export enum CATEGORY {
    DISPLAY = 'display',
    ACTION = 'action',
    INTERACTION = 'interaction'
}
